import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const BusinessService = () => {
    return <ServicesEditTemplate doc="business_immigration" service="Business Immigration" />;
};

export default BusinessService;
